import estados from "../../services/estados";

export const getAllowedSignatures = (allowedSignatures) =>
  Array.isArray(allowedSignatures) && allowedSignatures.length > 0
    ? allowedSignatures
    : ["M", "D", "E"];

export const getEstadoLabelForSign = (estadoValue) => {
  if (estadoValue === "NACIONAL") return "Nacional";
  return estados.find((e) => e.value === estadoValue)?.label || estadoValue || "";
};

// A preposição muda com o nome do estado: "na Bahia"/"na Paraíba" (femininos),
// "em São Paulo"/"em Minas Gerais" (os que não levam artigo) e "no Paraná" para
// o resto. Só as UFs que fogem do "no" entram aqui.
const PREPOSICAO_POR_UF = {
  BA: "na",
  PB: "na",
  AL: "em",
  GO: "em",
  MG: "em",
  PE: "em",
  RO: "em",
  RR: "em",
  SC: "em",
  SE: "em",
  SP: "em",
};

export const getPreposicaoParaEstado = (estadoValue) =>
  PREPOSICAO_POR_UF[estadoValue] || "no";

// hasCredential: para "D" indica se há certificado A1 cadastrado; para "E" indica se há assinatura eletrônica cadastrada.
export const getSignCardStatus = (type, allowedSignatures, estadoValue, hasCredential) => {
  const allowed = getAllowedSignatures(allowedSignatures);
  const estadoLabel = getEstadoLabelForSign(estadoValue);
  const preposicao = getPreposicaoParaEstado(estadoValue);

  if (!allowed.includes(type)) {
    return { variant: "disabled", text: `Não aceita ${preposicao} ${estadoLabel}` };
  }
  if (type === "M") {
    return { variant: "accepted", text: `Aceita ${preposicao} ${estadoLabel}` };
  }
  if (type === "E") {
    return hasCredential
      ? { variant: "accepted", text: "Assinatura cadastrada" }
      : { variant: "warning", text: "Falta cadastrar assinatura" };
  }
  return hasCredential
    ? { variant: "accepted", text: "Certificado cadastrado" }
    : { variant: "warning", text: "Falta enviar o certificado" };
};
